import React from 'react';

var MobileGameId = function (_a) {
    var id = _a.id, text = _a.text;
    return (React.createElement("div", { className: 'pgc-m-game-id-info' },
        React.createElement("p", { className: 'pgc-m-game-id-info-txt' }, text),
        React.createElement("p", { className: 'pgc-m-game-id-info-num' }, id)));
};

export { MobileGameId };
